import styled from 'styled-components';

export const Content = styled.div`
  text-align: left;

  .form-autocomplete {
    .select {
      box-shadow: 0 0 0 1px var(--color-form-field-focus-ring, var(--color-nav-active-bg));
    }
  }

  input {
    height: 40px;
  }

  .radioWrapper {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #000000;
    height: 24px;
    cursor: pointer;
    margin: 12px 0;

    &.disabled {
      color: #d5def2;
      cursor: auto;
    }

    .text {
      display: inline-block;
      margin-left: 10px;
    }
  }

  .customTable {
    height: 250px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 10px 0 0;

    tbody td > * {
      width: 100%;
    }
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: flex-start;
    margin-top: 20px;

    button {
      width: 130px;
    }
  }
`;
